import { getTranslatedOtherPostGradOption } from "../lists/qualification";
import { formatYesNoDropdownLists } from "../utils/form-data-utils";

export const formatQualificationOtherPostGradDataFormValues = (associate, language = "pt") => { 
    associate.qualificationData.hasOtherPostGrads = formatYesNoDropdownLists(associate.otherPostGrads.length > 0, language);

    for (let i = 0; i < associate.otherPostGrads.length; i++) {
        associate.otherPostGrads[i].acceptanceDate = associate.otherPostGrads[i].acceptanceDate !== null ? new Date(associate.otherPostGrads[i].acceptanceDate) : null;
        associate.otherPostGrads[i].endDate = associate.otherPostGrads[i].endDate !== null ? new Date(associate.otherPostGrads[i].endDate) : null;
        
        if(typeof associate.otherPostGrads[i].degreeLevel  !== 'object' && associate.otherPostGrads[i].degreeLevel !== null) {
            associate.otherPostGrads[i].degreeLevel = { name: associate.otherPostGrads[i].degreeLevel, code: associate.otherPostGrads[i].degreeLevel };
        }
        else if (typeof associate.otherPostGrads[i].degreeLevel === 'object' && associate.otherPostGrads[i].degreeLevel !== null) {
            associate.otherPostGrads[i].degreeLevel = getTranslatedOtherPostGradOption(associate.otherPostGrads[i].degreeLevel.code, language);
        }

        if(typeof associate.otherPostGrads[i].trainingCountry  !== 'object' && associate.otherPostGrads[i].trainingCountry !== null) {
            associate.otherPostGrads[i].trainingCountry = { name: associate.otherPostGrads[i].trainingCountry, code: associate.otherPostGrads[i].trainingCountry };
        }
    }

    return associate;
}

export const formatQualificationOtherPostGradDataToService = (associate) => { 
    for (let i = 0; i < associate.otherPostGrads.length; i++) {
        associate.otherPostGrads[i].degreeLevel = associate.otherPostGrads[i].degreeLevel.code;
        associate.otherPostGrads[i].trainingCountry = associate.otherPostGrads[i].trainingCountry.code;
    }

    return associate;
}